import { redirect } from 'react-router-dom';

export function Loader() {
  return redirect('/doohInventory');
}
